/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { isAuthorized } from "../../../helpers/AuthUtils";
import Advertisement from './Advertisement';
import { showApplicationStagesView } from '../actions/applicationStagesAction';
import InterviewPTLetterSchedule from './InterviewPTLetterSchedule';
import commonEnLabels from '../../../common/labels/common_en.json';
let headerField = [
    {
        "id": "1",
        "steps": "Step 1",
        "name": "Active Advertisements"
    },
    {
        "id": "2",
        "steps": "Step 2",
        "name": "Past Advertisements"
    },
    {
        "id": "3",
        "steps": "Step 3",
        "name": "Interview/PT Schedule"
    }
]

const ApplicationStages = () => {
    const dispatch = useDispatch();
    const [stepName, setName] = useState("1");
    const { authData } = useSelector(state => state.loginReducer, shallowEqual);
    let deptRoles = authData && authData.deptRoles && authData.deptRoles[0] && authData.deptRoles[0].roleId;
    const hasCreateApplicationStagePermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true :  isAuthorized(authData, null, "APPLICATION_STAGE", "C");
    const hasReadApplicationStagePermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true :  isAuthorized(authData, null, "APPLICATION_STAGE", "R");
    const hasUpdateApplicationStagePermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true :  isAuthorized(authData, null, "APPLICATION_STAGE", "U");
    const hasDeleteApplicationStagePermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true :  isAuthorized(authData, null, "APPLICATION_STAGE", "D");
    
    useEffect(()=>{
        window.scrollTo(0, 0);
    },[])

    return (
        authData &&
        <div className="tab-content border border-light w-100" id="myTabContentContainer" style={{ margin: "20px", position: "relative", top: "10px"}}>
            { (hasCreateApplicationStagePermission || hasReadApplicationStagePermission || hasUpdateApplicationStagePermission || hasDeleteApplicationStagePermission) === true ?
            <>
            <ul className="nav nav-tabs" id="myTab" role="tablist">
                {headerField && headerField.map((ele, index) =>
                    <li className="nav-item applicationHeaderCss" key={ele.id}>
                        <a className={stepName === ele.id ? "nav-link active" : "nav-link bg-profile-tabs"} value="home" href="#" id="home-tab" onClick={() =>{ setName(ele.id);dispatch(showApplicationStagesView(false))}} data-toggle="tab" role="tab" aria-controls="home" aria-selected="false">
                            <span>{ele.name}</span>
                        </a>
                    </li>
                )}
             
            </ul>
           
            <div className="tab-content border border-light" id="myTabContent">
                <div className={stepName === "1" ? "tab-pane show active" : "tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" style={{ backgroundColor: "#ffff", boxShadow: "0 0 5px rgb(0 0 0 / 10%), inset 0 -2px 0 #dfe1e2" }}>
                    <Advertisement 
                    isPast={false}
                    />
                </div>
                <div className={stepName === "2" ? "tab-pane show active" : "tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" style={{ backgroundColor: "#ffff" }}>
                    <Advertisement
                    isPast={true} 
                    />
                </div>
                <div className={stepName === "3" ? "tab-pane show active" : "tab-pane fade"} id="profile" role="tabpanel" aria-labelledby="profile-tab" style={{ backgroundColor: "#ffff" }}>
                    <InterviewPTLetterSchedule/>
                </div>
            </div>
            </> 
            :
                <div className="premium-permission-box">
                    <h1>{commonEnLabels.COMMON.ACCESS_DENIED}</h1>
                </div>
             }
        </div>

    )
}

export default ApplicationStages;